import styled from 'styled-components';
export var Container = styled.div.withConfig({
  displayName: "style__Container",
  componentId: "sc-3yodiq-0"
})(["width:100%;margin:0 auto 3em;"]);
export var PanelContainer = styled.div.withConfig({
  displayName: "style__PanelContainer",
  componentId: "sc-3yodiq-1"
})(["width:100%;display:flex;justify-content:center;align-items:center;flex-wrap:wrap;margin:0 auto 3em;height:500px;"]);